export default "__VITE_ASSET__usbcKWCQ__"